module.exports = __webpack_public_path__ + "img/OLDegg_sparkles.087b84a4.svg";